import { createContext, use, type ComponentProps } from "react";
import { MarkdownCode } from "@/components/common/MarkdownCode";
import { WorkspaceMarkdownLink } from "@/components/common/WorkspaceMarkdownLink";
import { openMentionedEnvironmentFile } from "@/lib/environment-files";
import { BODY_LINK_CLASS } from "@/lib/link-styles";
import { isMarkdownCodeBlock } from "@/lib/markdown-code-block";
import { filePathFromInlineCode } from "@/lib/markdown-file-link";

// リンクの中のインラインコードまでリンクにすると <a> が入れ子になり、リンク先と別のファイルを開いてしまう。
const InsideLinkContext = createContext(false);

export function ChatMarkdownLink(props: ComponentProps<typeof WorkspaceMarkdownLink>) {
	return (
		<InsideLinkContext value>
			<WorkspaceMarkdownLink {...props} />
		</InsideLinkContext>
	);
}

/** インラインコードがワークスペースのファイルのパスなら、押すと右ペインでそのファイルを開く。 */
export function WorkspaceInlineCode(props: ComponentProps<"code">) {
	const insideLink = use(InsideLinkContext);
	const filePath =
		!insideLink && !isMarkdownCodeBlock(props) && typeof props.children === "string"
			? filePathFromInlineCode(props.children)
			: null;
	if (filePath === null) return <MarkdownCode {...props} />;

	return (
		<a
			className={BODY_LINK_CLASS}
			onClick={() => {
				openMentionedEnvironmentFile(filePath).catch((err: unknown) => {
					console.error("Failed to open mentioned file", err);
				});
			}}
		>
			<MarkdownCode {...props} />
		</a>
	);
}
